import Swiper from "swiper/bundle";
window.addEventListener("load", function () {
  const swiper_mv = new Swiper(".js-mv", {
    loop: true,
    slidesPerView: 1,
    roundLengths: true,
    effect: "fade",
    speed: 3000,
    pagination: {
      el: ".mv-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000, // 1.5秒後に次のスライド
    },
  });
  const swiper = new Swiper(".js-about", {
    loop: true,
    slidesPerView: 3.8,
    speed: 8000,
    allowTouchMove: false,
    autoplay: {
      delay: 0, // 途切れなくループ
    },
    breakpoints: {
      // スライドの表示枚数：769px以上の場合
      768: {
        slidesPerView: 4.5,
      },
    },
  });
  const swiper_room = new Swiper(".js-room", {
    loop: true,
    slidesPerView: 1,
    //speed: 1000,
    roundLengths: true,
    pagination: {
      el: ".room-pagination",
      clickable: true,
    },
  });
  const swiper_menu = new Swiper(".js-menu", {
    loop: true,
    slidesPerView: 1,
    //speed: 1000,
    roundLengths: true,
    pagination: {
      el: ".menu-pagination",
      clickable: true,
    },
    breakpoints: {
      // スライドの表示枚数：769px以上の場合
      768: {
        slidesPerView: 1.5,
      },
    },
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  const swiper_text = new Swiper(".js-slider-text", {
    loop: true,
    slidesPerView: 1.8,
    speed: 20000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      769: {
        slidesPerView: 1.8,
      },
    },
  });
  const room_mv = new Swiper(".js-room-mv", {
    loop: true,
    slidesPerView: 1,
    roundLengths: true,
    effect: "fade",
    speed: 3000,
    pagination: {
      el: ".p-room-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000, // 1.5秒後に次のスライド
    },
  });
  const room_plan = new Swiper(".js-room-plan", {
    loop: true,
    slidesPerView: 1,
    roundLengths: true,
    pagination: {
      el: ".p-room-pagination02",
      clickable: true,
    },
  });
});
